<template>
  <div>
    <v-container class="py-10" id="cloud">
      <v-row class="align-center">
        <v-col cols="12" lg="6" class="pr-10">
          <div class="subtitle" style="color:#0391af">Appendix</div>
          <h2>66. Zukunftstechnologien neu</h2>
          <p style="color: green">
            <b>UPDATE</b>
          </p>
          <v-btn icon aria-hidden="true">
            <v-icon>mdi-share-variant</v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" aria-hidden="true">
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="download('image/jpeg')">
                <v-list-item-content>
                  <v-list-item-title>JPEG herunterladen</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="download('image/svg+xml')">
                <v-list-item-content>
                  <v-list-item-title>SVG herunterladen</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn
            icon
            aria-hidden="true"
            :to="{
              name: 'comparison',
              query: { var: 'konkrete Herausforderungen' }
            }"
          >
            <v-icon>mdi-chart-line</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" lg="6">
          <highcharts :options="chartOptions" ref="chart"></highcharts>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "A066",
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "bar"
        },
        title: {
          text:
            "Wie schätzen Sie das Potenzial dieser neuen Technologien für Ihre Organisation ein?​"
        },
        xAxis: {
          categories: [
            "3D-Druck​",
            "Blockchain​",
            "Internet of Things",
            "Virtual Reality",
            "Chatroboter​",
            "Künstliche Intelligenz​",
            "Cloud-Dienste​"
          ],
          labels: {
            align: "left",
            reserveSpace: true,
            style: {
              fontSize: "12"
            }
          }
        },
        yAxis: {
          min: 0,

          title: {
            text: "Prozent der Organisationen"
          }
        },
        legend: {
          enabled: true,
          reversed: true
        },
        plotOptions: {
          series: {
            stacking: "percent",
            events: {
              legendItemClick: function() {
                return false;
              }
            }
          }
        },
        tooltip: {
          headerFormat:
            '<span style="font-size:12px">{point.key}</span><table>',
          pointFormat:
            '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y:.1f}%</b></td></tr>',
          footerFormat: "</table>",
          shared: true,
          useHTML: true
        },
        colors: ["#546825", "#999", "#0391af", "#005a85"],
        series: [
          {
            name: "Großes bis sehr großes Potenzial​",
            data: [11.0, 4.1, 10.8, 14.7, 7.5, 12.1, 42.6]
          },
          {
            name: "Geringes bis mäßiges Potenzial",
            data: [17.2, 15.7, 24.5, 27.8, 20.8, 26.5, 49.7]
          },
          {
            name: "Kein Potenzial",
            data: [14.2, 46.1, 40.4, 42.3, 59.4, 51.2, 6.1]
          },
          {
            name: "Weiß nicht",
            data: [57.6, 34.1, 24.3, 15.0, 12.4, 10.2, 1.7]
          }
        ],
        exporting: {
          enabled: false,
          fallbackToExportServer: false,
          chartOptions: {
            chart: {
              backgroundColor: "#ffffff"
            }
          }
        }
      };
    }
  },
  methods: {
    download(type) {
      this.$refs.chart.chart.exportChartLocal({
        type: type
      });
    }
  }
};
</script>

<style scoped>
.chapter-color {
  background-color: #fff;
  min-height: 20em;
}
.component-color {
  background-color: #fff;
}
</style>
